import { useCallback, useLayoutEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import ToggleButton from '@/components/Button/ToggleButton'
import UIIcon, { UIIconRef } from '@/components/UI/UIIcon'
import { useGSAP } from '@/composables/useGSAP'
import { useRunnerState } from '@/composables/useRunnerState'

export default function RunnerPauseButton() {
  const { t } = useTranslation()
  const { gsap } = useGSAP()
  const { isIdle, actor, gameState } = useRunnerState()

  const buttonRef = useRef<HTMLLabelElement>(null)
  const elementRefs = useRef<UIIconRef[]>([])

  const isPaused = gameState.paused

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      if (elementRefs.current.length > 0) {
        gsap
          .timeline()
          .fromTo(
            elementRefs.current[1],
            { y: isPaused ? 0 : 6 },
            { y: isPaused ? 6 : 0, duration: 0.5, ease: 'back.out(1.7)' },
            0
          )
          .fromTo(
            elementRefs.current[2],
            { scale: isPaused ? 1 : 0 },
            { scale: isPaused ? 0 : 1, duration: 0.5, ease: 'back.out(1.7)' },
            0
          )
          .fromTo(
            elementRefs.current[3],
            { x: isPaused ? 0 : -12 },
            { x: isPaused ? -12 : 0, duration: 0.5, ease: 'back.out(1.7)' },
            0
          )
      }
    })

    return () => ctx.revert()
  }, [isPaused, elementRefs, gsap])

  const setChecked = useCallback(
    (checked: boolean) => {
      actor.send({ type: checked ? 'PAUSE' : 'RESUME' })
    },
    [actor]
  )

  return (
    !isIdle &&
    !isPaused && (
      <ToggleButton
        ref={buttonRef}
        // icon="pause"
        // iconChecked="next"
        checked={isPaused}
        setChecked={setChecked}
        theme='text-scarlet'
        label={t('runner.pause')}
        labelPosition='left'
        labelTheme='pill'
        labelClassName='!hidden'
      >
        {/* {!checked && <UIIcon className="ToggleButton__Icon text-40 relative group-hover:scale-95 transition-transform duration-333 ease-out-quad" icon={icon} />}
      {checked && <UIIcon className="ToggleButton__Icon text-40 relative group-hover:scale-95 transition-transform duration-333 ease-out-quad" icon={iconChecked} />} */}
        <div
          id='pause_button'
          className='absolute size-full inset-0 flex justify-center items-center'
          title={isPaused ? t('runner.play') : t('runner.pause')}
        >
          {!isPaused && (
            <UIIcon
              className='ToggleButton__Icon text-16 relative group-hover:scale-95 transition-transform duration-333 ease-out-quad text-dark-blue fill-current'
              icon='pause'
            />
          )}
          {isPaused && (
            <UIIcon
              className='ToggleButton__Icon text-16 relative group-hover:scale-95 transition-transform duration-333 ease-out-quad text-dark-blue fill-current'
              icon='play'
            />
          )}
        </div>
      </ToggleButton>
    )
  )
}
